var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"w-100 h-100 justify-content-center d-flex"},[_c('transition',{attrs:{"name":"switch","mode":"out-in"}},[_c('router-view')],1),_c('transition',{attrs:{"name":"showAlert"}},[(_vm.showAlert)?_c('div',{staticClass:"alert"},[_c('div',{staticClass:"alertMessage"},[_vm._v(_vm._s(_vm.message))])]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }